import { Button, makeStyles, Typography } from "@material-ui/core";
import { opacity } from "html2canvas/dist/types/css/property-descriptors/opacity";
import { FC } from "react";

interface DialogButtonProps {
  buttonText: string;
  onClick: (arg: any) => void;
  customClass?: any;
  customStyle?: any;
  variant?: "text" | "outlined" | "contained";
  icon?: any;
  secondIcon?: any;
  disabled?: boolean;
  theme?: "blue" | "red";
  mobileScreenSpread?: boolean;
  swapPositions?: boolean;
  component?: any;
}

export const CustomButton: FC<DialogButtonProps> = ({
  customClass,
  buttonText,
  customStyle,
  variant,
  onClick,
  theme,
  icon,
  secondIcon,
  disabled,
  mobileScreenSpread,
  swapPositions,
  component,
}) => {
  const classes = useStyles();

  return (
    <Button
      component={component ? component : "button"}
      disabled={disabled}
      style={customStyle}
      variant={variant}
      onClick={onClick}
      className={`${classes.root} ${customClass} ${
        variant === "contained"
          ? classes.button
          : variant === "outlined"
            ? classes.outlinedBtn
            : classes.textBtn
      } ${theme ? classes[`${theme}Theme`] : variant === "contained" ? classes.blueTheme : ""} ${
        mobileScreenSpread ? classes.mobileScreenSpread : ""
      }`}
    >
      {!swapPositions ? icon : secondIcon}
      <Typography>{buttonText}</Typography>
      {!swapPositions ? secondIcon : icon}
    </Button>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1, 1.5),
    "& .MuiButton-label": {
      display: "flex",
      gap: theme.spacing(1),
    },
        "&.Mui-disabled": {
      opacity: 0.3,
    },
  },
  outlinedBtn: {
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(0.5),
    "&.MuiButton-outlined": {
      border: "1px solid #828487",
      color: "#828487",
    },
  },
  button: {
    color: "white",
    "& .MuiTypography-root": {
      color: "white",
    },
    "&.MuiButton-contained.Mui-disabled": {
      color: "white",
    },
  },
  blueTheme: {
    "&.MuiButton-contained": {
      background: "#0129FA",
      "&:hover": {
        background: "#011da7",
      },
      "&:focus": {
        background: "#4b68fa",
      },
      "&.Mui-disabled": {
        background: "#b2bffd",
      },
    },
    "&.MuiButton-text": {
      color: "#0129FA",
      "& .MuiTypography-root": {
        color: "#0129FA",
      },
    },
    "&.MuiButton-outlined": {
      borderColor: "#0129FA",
      color: "#0129FA",
      "& .MuiTypography-root": {
        color: "#0129FA",
      },
    },
  },
  redTheme: {
    "&.MuiButton-contained": {
      background: "#C42020",
      "&:hover": {
        background: "#881414",
      },
      "&:focus": {
        background: "#d46161",
      },
      "&.Mui-disabled": {
        background: "#C42020",
      },
    },
    "&.MuiButton-text": {
      color: "#C42020",
      "& .MuiTypography-root": {
        color: "#C42020",
      },
    },
    "&.MuiButton-outlined": {
      borderColor: "#C42020",
      color: "#C42020",
      "& .MuiTypography-root": {
        color: "#C42020",
      },
    },
  },
  textBtn: {
    color: "black",
    padding: theme.spacing(1, 2, 1, 1),
  },
  mobileScreenSpread: {},
  "@media (max-width: 840px)": {
    mobileScreenSpread: {
      flexGrow: 1,
    },
  },
}));
